module.exports = __webpack_public_path__ + "static/media/Q1_Front_Left.da20f3fd.png";